/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import { useAuth } from '../../../../app/modules/auth'

//import {Languages} from './Languages'

// import { getAuth } from "firebase/auth"; // No longer needed directly here

const HeaderUserMenu: FC = () => {
  const { logout } = useAuth() // Use the logout from AuthContext
  const navigate = useNavigate() // Renamed to navigate for clarity and convention

  const handleLogout = async () => {
    console.log('[HeaderUserMenu] Attempting logout via AuthContext...');
    const logoutSuccessful = await logout(); // This is the async logout from AuthContext
    console.log(`[HeaderUserMenu] AuthContext logout() completed. Success: ${logoutSuccessful}`);
    
    if (logoutSuccessful) {
      // TEMPORARY DELAY REMOVED FOR DIAGNOSIS
      // console.log('[HeaderUserMenu] Firebase sign-out successful. Waiting 2 seconds before localStorage clear and navigation...');
      // await new Promise(resolve => setTimeout(resolve, 2000)); // 2-second delay
      // console.log('[HeaderUserMenu] Delay finished. Clearing localStorage and navigating now.');
      console.log('[HeaderUserMenu] Firebase sign-out successful. Proceeding with localStorage clear and navigation immediately.');
      
      localStorage.removeItem('user'); 
      localStorage.removeItem('user_uid'); 
      localStorage.removeItem('role'); 
      localStorage.removeItem('display_name');
      localStorage.removeItem('email');
      
      navigate('/auth');
    } else {
      console.error('[HeaderUserMenu] Firebase sign-out failed. Navigation and full cleanup aborted.');
      // Optionally, show a message to the user that logout failed.
    }
  };

  // get user data (firsname  and email) from localStorage
  let localData :any = localStorage.getItem('user')
  const local :any = JSON.parse(localData);
     return (
    <div
    className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
    data-kt-menu='true'
    data-popper-placement='bottom-start'
     >
    {/* <div className='menu-item px-3'>
      <div className='menu-content d-flex align-items-center px-3'>
        <div className='symbol symbol-50px me-5'>
        <img src={toAbsoluteUrl(localStorage.getItem('profile_image_url') || '/media/avatars/blank.png') }referrerPolicy="no-referrer" alt='' />
        </div>

        <div className='d-flex flex-column'>
          <div className='fw-bolder d-flex align-items-center fs-5'>        
          Get display name from localStorage  
          {localStorage.getItem('display_name')} 
          ---------------------------------------------
            <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>Admin</span>
          </div>
          <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
            {currentUser?.email}
            
          </a>
        </div>
      </div>
    </div> */}

    <div className='separator my-2'></div>

    

    {/* <div className='menu-item px-5'>
      <a href='#' className='menu-link px-5'>
        Open Projects
      </a>
    </div> */}

    {/* <div
      className='menu-item px-5'
      data-kt-menu-trigger='hover'
      data-kt-menu-placement='left-start'
      data-kt-menu-flip='bottom'
    > */}
      {/* <a href='#' className='menu-link px-5'>
        <span className='menu-title'>Monthly Clients</span> */}
        {/* <span className='menu-arrow'></span> */}
      {/* </a> */}

      {/* <div className='menu-sub menu-sub-dropdown w-175px py-4'>
        <div className='menu-item px-3'>
          <a href='#' className='menu-link px-5'>
            Referrals
          </a>
        </div>

        <div className='menu-item px-3'>
          <a href='#' className='menu-link px-5'>
            Billing
          </a>
        </div>

        <div className='menu-item px-3'>
          <a href='#' className='menu-link px-5'>
            Payments
          </a>
        </div>

        <div className='menu-item px-3'>
          <a href='#' className='menu-link d-flex flex-stack px-5'>
            Statements
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='View your statements'
            ></i>
          </a>
        </div>

        <div className='separator my-2'></div>

        <div className='menu-item px-3'>
          <div className='menu-content px-3'>
            <label className='form-check form-switch form-check-custom form-check-solid'>
              <input
                className='form-check-input w-30px h-20px'
                type='checkbox'
                value='1'
                defaultChecked={true}
                name='notifications'
              />
              <span className='form-check-label text-muted fs-7'>Notifications</span>
            </label>
          </div>
        </div>
      </div> */}
    {/* </div> */}

    {/* <div className='menu-item px-5'>
      <a href='#' className='menu-link px-5'>
        Usage Statistics
      </a>
    </div> */}

    {/* <div className='separator my-2'></div> */}

    {/* <Languages /> */}

    {/* <div className='menu-item px-5'>
      <Link to={'/user/account/profile'} className='menu-link px-5'>
        Account Profile
      </Link>
    </div> */}

    <div className='menu-item px-5 my-1'>
      <Link to='/user/account/settings' className='menu-link px-5'>
        Account Settings
      </Link>
    </div>
    <div className='separator my-2'></div>
    <div className='menu-item px-5'>
    <a onClick={handleLogout} className='menu-link px-5'>
      Sign Out
    </a>
  </div>
</div>
);
};

export {HeaderUserMenu}
